export const TaskTypeToRoleMapping = {
  ASM: "ASM",
  AGENT: "Agent",
  FOS: "FOS",
  Consumer: "Consumer"
};
